(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["martello-countdown"] && !Shopify.designMode) return;
  try {
    

  if (!customElements.get('martello-hero-countdown')) {
    customElements.define('martello-hero-countdown', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.clock);
        this.parts = Object.fromEntries(Array.from(this.querySelectorAll('[data-part]'), node => [node.dataset.part, node]));
        this.digits = this.querySelector('.mc-countdown__digits');
        this.message = this.querySelector('.mc-countdown__expired');
        this.hidden = true;
        const date = /^(\d{4})-(\d{2})-(\d{2})$/.exec((this.dataset.date || '').trim());
        const time = /^(\d{2}):(\d{2}):(\d{2})$/.exec((this.dataset.time || '').trim());
        let valid = false;
        if (date && time) {
          const [year, month, day] = date.slice(1).map(Number);
          const [hour, minute, second] = time.slice(1).map(Number);
          const target = new Date(year, month - 1, day, hour, minute, second);
          valid = year >= 2000 && year <= 9999 && target.getFullYear() === year && target.getMonth() === month - 1 && target.getDate() === day && target.getHours() === hour && target.getMinutes() === minute && target.getSeconds() === second;
          this.deadline = target.getTime();
        }
        const error = this.parentElement.querySelector('[data-mc-error]');
        if (error) error.hidden = valid;
        if (!valid) return;
        this.digits.hidden = false;
        this.message.hidden = true;
        this.hidden = false;
        this.update();
        if (this.deadline > Date.now()) this.clock = setInterval(() => this.update(), 1000);
      }
      disconnectedCallback() { clearInterval(this.clock); }
      update() {
        const total = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        const values = {
          days: Math.floor(total / 86400),
          hours: this.parts.days ? Math.floor(total / 3600) % 24 : Math.floor(total / 3600),
          minutes: Math.floor(total / 60) % 60,
          seconds: total % 60
        };
        for (const [key, node] of Object.entries(this.parts)) {
          const text = String(values[key]).padStart(2, '0');
          if (node.textContent !== text) node.textContent = text;
        }
        if (total === 0) {
          clearInterval(this.clock);
          if (this.dataset.expiry === 'hide') this.hidden = true;
          if (this.dataset.expiry === 'message') {
            this.digits.hidden = true;
            this.message.hidden = false;
          }
        }
      }
    });
  }


  } catch(e) { console.error(e); }
})();
})();
